import { useEffect, useState } from "react";
import useAuth from "src/hooks/useAuth";
import { useLocation, Navigate, useNavigate } from "react-router-dom";

// pages
import Login from "src/pages/auth/Login";
import LoadingScreen from "src/components/LoadingScreen";
import { AuthLayoutComp } from "src/layouts/auth/index";
import EmailOTP from "src/pages/auth/EmailOTP";

export default function AuthGuard({ children }) {
  // Track search too so deep links like /dashboard/robo-advisor?key=...
  // survive the login round-trip intact.
  const { pathname, search } = useLocation();
  const fullPath = pathname + search;
  const [requestedLocation, setRequestedLocation] = useState(null);
  const [paymentPopupCanceled, setPaymentPopupCanceled] = useState(false);
  const { isAuthenticated, isInitialized, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      user &&
      user.subscription &&
      user.subscription.setup_status.payment === false
    ) {
      // Check if the flag is already set in local storage
      const flagSet = localStorage.getItem("paymentPopupFlag");

      if (!flagSet) {
        // Set the flag in local storage
        localStorage.setItem("paymentPopupFlag", "true");

        // Set the state to true to trigger the redirect
        setPaymentPopupCanceled(true);
      }
    }
  }, [user]);

  useEffect(() => {
    if (paymentPopupCanceled) {
      setPaymentPopupCanceled(false);
      navigate("/make-payment");
    }
  }, [paymentPopupCanceled, navigate]);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (fullPath !== requestedLocation) {
      setRequestedLocation(fullPath);
    }
    return (
      <AuthLayoutComp>
        <Login />
      </AuthLayoutComp>
    );
  }

  if (
    user.subscription?.setup_status.payment &&
    !user.subscription?.setup_status?.otp
  ) {
    return <EmailOTP />;
  }

  if (requestedLocation && fullPath !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }
  return <>{children}</>;
}
